module.exports = __webpack_public_path__ + "images/skewness-17-desktop.png";